import { Activity, Workflow } from "../../workflowModel";
import { ActivityPoistionSearchResult } from "./types";

/**
 * Funkce vrací seznam všech pozic aktivit vyfiltrovaných podle klíčového slova. Zároveň vrací pouze prvních 25 výsledků.
 * @param workflow Instance workflow odpovídající aktuální instanci editoru WF.
 * @param keyword Klíčové slovo podle kterého se mají vyhledávat aktivity, porovnávání je case insensitive.
 */
export const getActivitySearchResults = (workflow: Workflow, keyword: string) => {
    if (keyword === "")
        return [];

    const lowerCaseKeyword = keyword.toLowerCase();

    // Vyhledá aktivity podle keywordu a seřadí je podle hodnoty indexu keywordu v názvů
    const filteredActivities = workflow.activities.filter(activity => activity.name.toLowerCase().includes(lowerCaseKeyword))
        .sort((a, b) => a.name.toLowerCase().indexOf(lowerCaseKeyword) - b.name.toLowerCase().indexOf(lowerCaseKeyword));

    const result = filteredActivities.slice(0, 25).reduce((prev, cur) => (
        [...prev, ...getActivityPositions(cur)]
    ), [] as ActivityPoistionSearchResult[]);

    return result.slice(0, 25);
};

/**
 * Vrací seznam search resultů pro danou aktivitu.
 * @param activity
 */
const getActivityPositions = (activity: Activity): ActivityPoistionSearchResult[] => (
    activity.positions.map(position => ({
        activityId: activity.id,
        activityName: activity.name,
        setId: position.set.id,
        setName: position.set.name,
    }))
);
